/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-return */
import requestDefault from '@/shared/utils/request';
import {
  ApplyTempAmountResult,
  EventLoopNotifyResult,
  EventLoopNotifySceneEnum,
  TempAmountSceneEnum,
  ShowLoanPageEntryResult,
} from './types';

/**
 * 临时额度实时触发链路：https://metis2.hellobike.cn/browse/SKXDZC-7924
 * 当用户满足条件触发申请临额后，信贷服务请求风控系统，同步返回临额是否可以下发的结果，此时风控异步去下发临额金额(通常3-4秒可完成下发)
 */

/**
 * 申请-下发临时额度
 * yapi: https://yapi.hellobike.cn/project/3415/interface/api/366914
 */
export const applyTempAmount = (scene: TempAmountSceneEnum):
Promise<ApplyTempAmountResult> => requestDefault.postGate(
  'f.tempAmount.apply',
  { scene },
  {
    showLoading: undefined,
    showErrMsg: undefined,
  },
);

/**
 * 轮询查询-服务端有无-消息通知
 * author: 杨钊
 * 技术文档: https://hellobike.yuque.com/yxr77w/hmqvkh/bz7kpy2hkltm001l#EKPua
 */
export const eventLoopQueryNotify = (loopSceneList: EventLoopNotifySceneEnum[]):
  Promise<{ frontEventLoopInnerRespList: EventLoopNotifyResult[] }> => requestDefault.postGate(
  'f.front.event.loop',
  { loopSceneList },
  {
    showLoading: undefined,
    showErrMsg: undefined,
  },
);

/**
 * 判断是否展示提额入口
 * @description 优质老客在提现页面展示提额入口判断
 */
export const showLoanPageTempAmountEntry = ():
  Promise<ShowLoanPageEntryResult> => requestDefault.postGate(
  'f.tempAmount.loanPage.show',
  {},
  {
    showLoading: undefined,
    showErrMsg: undefined,
  },
);
